import {OrderProvider} from 'providers/OrderProvider'

function EnvironmentWarning() {
  const order = OrderProvider.useOrder('optional')
  const isLocal = window.location.hostname === 'localhost'

  if (isLocal && order && !order.testMode) {
    return (
      <div className="bg-red-700 text-white px-10 p-6 rounded-xl mb-8 text-lg">
        <strong>Warning:</strong> You are testing using a <strong>production</strong> Ventrata API key.
      </div>
    )
  }

  return null
}

export default EnvironmentWarning
